var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgMoneyTransfer16X16 = function SvgMoneyTransfer16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#money-transfer-16x16_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.855 1.067C4.1 1.067 1.067 3.822 1.067 8A.533.533 0 010 8c0-4.782 3.524-8 7.855-8 2.894 0 5.375 1.284 6.71 3.437l.384-1.54a.533.533 0 111.035.26l-.743 2.974a.544.544 0 01-.246.34.533.533 0 01-.404.06l-2.987-.747a.533.533 0 11.259-1.034l1.93.482c-1.08-1.941-3.255-3.165-5.938-3.165zm.883 6.381c-.5-.177-1.051-.39-1.36-.633-.098-.077-.14-.252-.105-.436.017-.092.098-.399.411-.493.514-.156.867.05.995.146a.553.553 0 00.66-.885 2.198 2.198 0 00-.821-.37v-.224a.552.552 0 10-1.103 0v.26l-.016.005-.033.01c-.604.182-1.055.698-1.177 1.346-.113.597.082 1.176.508 1.51.35.276.835.51 1.673.806.558.198.546.65.515.836a.93.93 0 01-.922.785c-.533.004-.7-.023-1.11-.291a.553.553 0 00-.604.925c.443.29.769.407 1.166.45v.252a.552.552 0 101.103 0v-.305c.304-.084.58-.237.817-.455.336-.31.562-.727.638-1.178.153-.917-.343-1.745-1.235-2.061zM16 8a.533.533 0 00-1.066 0c0 4.179-3.032 6.933-6.789 6.933-2.681 0-4.857-1.223-5.938-3.165l1.93.483a.533.533 0 00.26-1.035l-2.988-.747a.534.534 0 00-.646.388l-.747 2.987a.533.533 0 001.035.259l.385-1.54C2.77 14.715 5.252 16 8.146 16 12.475 16 16 12.782 16 8z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "money-transfer-16x16_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

export default SvgMoneyTransfer16X16;